import { render, staticRenderFns } from "./MobilePreventionSafetyRequestCreate.vue?vue&type=template&id=ad70d2a4&scoped=true&"
import script from "./MobilePreventionSafetyRequestCreate.vue?vue&type=script&lang=js&"
export * from "./MobilePreventionSafetyRequestCreate.vue?vue&type=script&lang=js&"
import style0 from "./MobilePreventionSafetyRequestCreate.vue?vue&type=style&index=0&id=ad70d2a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad70d2a4",
  null
  
)

export default component.exports